import { render, staticRenderFns } from "./PatientDetailAssignDoctor.vue?vue&type=template&id=3971c1ec&scoped=true&"
import script from "./PatientDetailAssignDoctor.vue?vue&type=script&lang=ts&"
export * from "./PatientDetailAssignDoctor.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDetailAssignDoctor.vue?vue&type=style&index=0&id=3971c1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3971c1ec",
  null
  
)

export default component.exports